import React from 'react'
import { Link } from "react-router-dom"
import { Row, Col, Typography, Card, Avatar, Descriptions, Button, message } from 'antd'
import { UserOutlined, EditOutlined } from '@ant-design/icons'
import PropTypes from 'prop-types'
import StorageUtils from '../../utils/StorageUtils'
import { reqAccountInfo } from '../../api'

import Account_img from '../../images/user/account.png'

const { Title } = Typography
const { Meta } = Card

class Account extends React.Component {
    state = {
        user: ''
    }

    async componentDidMount() {
        const pathSnippets = this.props.location.pathname.split('/').filter(i => i)
        this.props.setPathSnippetsState(pathSnippets)

        const user = StorageUtils.getUser()
        
        const result = await reqAccountInfo()
        if (result.code === 0) {
            this.setState({user: result.data})
        } else {
            message.error(result.message)
        }
    }

    render() {
        const { user } = this.state
        return (
            <React.Fragment>
                <Row justify="center">
                    <Col>
                        <Title level={3}>User Account</Title>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col span={8} lg={8} xxl={6}>
                        <Card style={{ width: 300 }} 
                            cover={ <img src={Account_img} /> }
                            actions={[
                                <Link to="/user/account/edit"><EditOutlined key="edit" /> Modify</Link>,
                            ]}
                        >
                            <Meta
                                avatar={<Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} size="large" />}
                                title={<span>{user.username}</span>}
                                description="CottonGVD Account"
                            />
                        </Card>
                    </Col>
                    <Col span="16">
                        <Descriptions column={2} bordered>
                            <Descriptions.Item label="Usernname">{user.username}</Descriptions.Item>
                            <Descriptions.Item label="Email">{user.email}</Descriptions.Item>
                            <Descriptions.Item label="Register Date">{user.date_joined}</Descriptions.Item>
                            <Descriptions.Item label="First Name">{user.first_name}</Descriptions.Item>
                            <Descriptions.Item label="Last Name">{user.last_name}</Descriptions.Item>
                        </Descriptions>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

Account.propTypes = {
    setPathSnippetsState: PropTypes.func
}

export default Account